import React from 'react';
import { BulkFileUploaderLayout } from './components/BulkFileUploaderLayout';
import type { MetaValidationMode } from './types';

interface BulkFileUploaderProps {
  className?: string;
  style?: React.CSSProperties;
  canUpload?: boolean;
  metaValidationMode?: MetaValidationMode;
}

export const BulkFileUploader: React.FC<BulkFileUploaderProps> = props => {
  return <BulkFileUploaderLayout {...props} />;
};
